import util from "@/lib/util";
import { toTwoDecimals } from "@/lib/payments";

/**
 * Parse the text of the expense quantity input. The schema type is float, so a fractional
 * quantity is kept, and a cleared input is null rather than an error. (OWA-1602)
 */
export function parseExpenseQuantity(text: string | number | null | undefined): number | null {
  if (typeof text === "string" && text.trim() === "") return null;

  return util.parseFloat(text ?? null);
}

/**
 * The total of one expense line: quantity times rate, rounded half-up to cents by the payments kernel
 * (1.5 at 40 is 60.00; 3 at 0.175 is 0.53). A cleared quantity or rate counts as 0. (OWA-1602)
 */
export function expenseLineTotal(quantity: number | null | undefined, cost: number | null | undefined): number {
  return toTwoDecimals((quantity ?? 0) * (cost ?? 0));
}
